<template>
  <el-dialog
      :title="'新增暂估价生成对应关系'"
      :close-on-click-modal="false"
      width="30%"
      :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px" class="position-dialog-form">
      <!-- 源采购组织下拉框 -->
      <el-form-item label="源采购组织" prop="objectPurName">
        <el-select
            v-model="dataForm.objectPurId"
            placeholder="请选择源采购组织"
            @change="handleObjectPurChange"
            clearable
            filterable>
          <el-option
              v-for="item in purOrgList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            <span>{{ item.code }} - {{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 目标采购组织下拉框 -->
      <el-form-item label="目标采购组织" prop="subjectPurName">
        <el-select
            v-model="dataForm.subjectPurId"
            placeholder="请选择目标采购组织"
            @change="handleSubjectPurChange"
            clearable
            filterable>
          <el-option
              v-for="item in purOrgList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            <span>{{ item.code }} - {{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 目标工厂下拉框 -->
      <el-form-item label="目标工厂" prop="subjectWorkName">
        <el-select
            v-model="dataForm.subjectWorkId"
            placeholder="请先选择目标采购组织"
            :disabled="!dataForm.subjectPurId"
            @change="handleSubjectWorkChange"
            clearable
            filterable>
          <el-option
              v-for="item in factoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            <span>{{ item.code }} - {{ item.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="small" @click="view.visible = false">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()">
          确定
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import {
  insertZgPrice,
  queryPurList,
  targetPurWorkList
} from '@/controller/rfq'

export default {
  data () {
    return {
      purOrgList: [], // 采购组织列表
      factoryList: [], // 工厂列表
      view: {
        visible: false,
        conheight: {
          height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
          'overflow-y': 'auto'
        }
      },
      dataForm: {
        objectPurId: '',       // 源采购组织ID
        subjectPurId: '',      // 目标采购组织ID
        subjectWorkId: '',     // 目标工厂ID
        objectPurCode: '',     // 源采购组织编码
        subjectPurCode: '',    // 目标采购组织编码
        subjectWorkCode: '',   // 目标工厂编码
        objectPurName: '',     // 源采购组织名称
        subjectPurName: '',    // 目标采购组织名称
        subjectWorkName: '',   // 目标工厂名称
        name: '',
        code: '',
        tenantId: '',
        tenantName: '',
        orgId: ''
      },
      dataRule: {
        objectPurId: [
          { required: true, message: '源采购组织不能为空', trigger: 'blur' }
        ],
        subjectPurId: [
          { required: true, message: '目标采购组织不能为空', trigger: 'blur' }
        ],
        subjectWorkId: [
          { required: true, message: '目标工厂不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.view.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm.tenantId = sessionStorage.getItem('tenantId')
        this.loadPurOrganizations() // 加载采购组织
      })
    },

    // 加载采购组织列表
    async loadPurOrganizations() {
      try {
        const response = await queryPurList()
        if (response && response.code === '00') {
          this.purOrgList = response.body || []
        } else {
          this.$message.error(response.msg || '获取采购组织失败')
        }
      } catch (error) {
        console.error('获取采购组织异常:', error)
        this.$message.error('获取采购组织异常')
      }
    },

    // 源采购组织变更处理
    handleObjectPurChange(selectedId) {
      const selectedOrg = this.purOrgList.find(item => item.id === selectedId)
      if (selectedOrg) {
        this.dataForm.objectPurId = selectedOrg.id
        this.dataForm.objectPurCode = selectedOrg.code
        this.dataForm.objectPurName = selectedOrg.name
      }
    },

    // 目标采购组织变更处理
    async handleSubjectPurChange(selectedId) {
      const selectedOrg = this.purOrgList.find(item => item.id === selectedId)
      if (selectedOrg) {
        this.dataForm.subjectPurId =selectedOrg.id
        this.dataForm.subjectPurCode = selectedOrg.code
        this.dataForm.subjectPurName = selectedOrg.name
        this.dataForm.subjectWorkId = '' // 清空工厂选择

        // 加载目标工厂
        try {
          const response = await targetPurWorkList({'subjectPurId':selectedId})
          if (response && response.code === '00') {
            this.factoryList = response.body || []
          } else {
            this.$message.error(response.msg || '获取工厂列表失败')
            this.factoryList = []
          }
        } catch (error) {
          console.error('获取工厂异常:', error)
          this.$message.error('获取工厂异常')
          this.factoryList = []
        }
      }
    },

    // 目标工厂变更处理
    handleSubjectWorkChange(selectedId) {
      const selectedFactory = this.factoryList.find(item => item.id === selectedId)
      if (selectedFactory) {
        this.dataForm.subjectWorkId = selectedFactory.id
        this.dataForm.subjectWorkCode = selectedFactory.code
        this.dataForm.subjectWorkName = selectedFactory.name
      }
    },

    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate(async (valid) => {
        if (valid) {
          try {
            const params = {...this.dataForm}
            const response = await insertZgPrice(params)

            if (response && response.code === '00') {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.view.visible = false
                  this.$emit('refreshDataList')
                  // 清空表单数据
                  Object.keys(this.dataForm).forEach(key => {
                    if (!['tenantId', 'tenantName', 'orgId'].includes(key)) {
                      this.dataForm[key] = ''
                    }
                  })
                }
              })
            } else {
              this.$message.error(response.msg || '操作失败')
            }
          } catch (error) {
            console.error('保存异常:', error)
            this.$message.error('保存异常')
          }
        }
      })
    }
  }
}
</script>
